import { render, staticRenderFns } from "./ButtonsFooter.vue?vue&type=template&id=306a7da9&scoped=true&"
import script from "./ButtonsFooter.vue?vue&type=script&lang=js&"
export * from "./ButtonsFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306a7da9",
  null
  
)

export default component.exports